/* Living Oliva · megamenú: al cruzar otro enlace del menú camino del desplegable no se cierra (02/10/2026) */
(function(){
  function init(){
    var nav=document.querySelector('nav.js-nav'); if(!nav||nav.dataset.loFix) return; nav.dataset.loFix='1';
    var timer=null, passing=false;
    nav.addEventListener('mouseenter',function(e){
      if(passing) return;
      var it=e.target;
      if(!it||!it.matches||!it.matches('.js-nav-item[data-menu-item]')) return;
      var open=nav.querySelector('.js-dropdown.is-visible');
      if(!open||it.contains(open)) return;
      e.stopImmediatePropagation();
      clearTimeout(timer);
      timer=setTimeout(function(){
        if(it.matches(':hover')){passing=true;it.dispatchEvent(new MouseEvent('mouseenter'));passing=false;}
      },350);
    },true);
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
})();
